import { UpdateCategoryRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdateCategoryRequest';
import { createCategoryHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/CategoryHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateCategory = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createCategoryHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateCategoryRequest }) => {
      if (!repository) throw new Error('Repository not initialized');
      return await repository.update(id, data);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['categories'] });
      queryClient.invalidateQueries({ queryKey: ['category', variables.id] });
    },
  });
};
